import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MobileBottomNav from "../components/common/MobileBottomNav";

const JoinUs = () => {
    const navigate = useNavigate();

    const handleSelect = (userType) => {
        if (userType === "builder") {
            navigate("/builder/signup");
        } else if (userType === "customer") {
            navigate("/customer/signup");
        }
    };

    return (
        <div className="w-full h-[100dvh] overflow-hidden bg-black relative">
            <Helmet>
                <title>Join Ducktail | The Construction Platform</title>
                <meta name="robots" content="noindex" />
                <link rel="canonical" href="https://www.ducktail.in/" />
            </Helmet>
            {/* Background - Darkened */}
            <div className="absolute inset-0 z-0">
                <img
                    src="/assets/Landscaping.jpg"
                    alt="Background"
                    className="absolute inset-0 w-full h-full object-cover object-center blur-sm scale-110 opacity-60"
                />
                {/* Black Overlay for Dark Theme */}
                <div className="absolute inset-0 bg-black/70 backdrop-blur-[1px]"></div>
            </div>

            {/* Main Content Container - Flex Column to fit viewport */}
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center pb-20 px-4">

                {/* Header Section */}
                <div className="text-center mb-4 md:mb-8 animate-fade-in-down">
                    <span className="block text-yellow-400 font-bold tracking-widest uppercase text-xs md:text-sm mb-1">
                        Get Started
                    </span>
                    <h1 className="text-3xl md:text-5xl font-black text-white mb-2 tracking-tight drop-shadow-md">
                        Join <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200">Ducktail</span>
                    </h1>
                    <p className="text-gray-300 text-sm md:text-lg max-w-md mx-auto leading-tight font-light hidden sm:block">
                        The construction platform that brings builders and customers together.
                    </p>
                    <p className="text-gray-300 text-xs max-w-xs mx-auto leading-tight font-light sm:hidden">
                        Connecting builders and customers.
                    </p>
                </div>

                {/* Cards Container */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-sm md:max-w-3xl">

                    {/* Builder Card */}
                    <div
                        onClick={() => handleSelect("builder")}
                        className="group relative bg-white/95 backdrop-blur-sm rounded-2xl p-4 md:p-6 shadow-[0_0_20px_rgba(0,0,0,0.3)] hover:shadow-[0_0_30px_rgba(250,204,21,0.2)] transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-white/10 overflow-hidden flex flex-row md:flex-col items-center md:items-start gap-4"
                    >
                        <div className="bg-yellow-50 rounded-xl p-2 md:p-3 flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                            <img src="/assets/builder.png" alt="Builder" className="w-10 h-10 md:w-16 md:h-16 object-contain" />
                        </div>

                        <div className="flex flex-col text-left">
                            <h3 className="text-lg md:text-2xl font-bold text-gray-900 leading-none mb-1 group-hover:text-yellow-600 transition-colors">
                                I am a Builder
                            </h3>
                            <p className="text-gray-600 text-xs md:text-sm mb-2 font-medium leading-tight line-clamp-2">
                                Showcase projects & grow your business.
                            </p>
                            <div className="flex items-center text-yellow-600 text-xs md:text-sm font-bold group-hover:translate-x-1 transition-transform">
                                <span>Register Now</span>
                                <svg className="w-3 h-3 md:w-4 md:h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </div>
                        </div>

                        <div className="absolute top-0 right-0 p-2 opacity-5 pointer-events-none group-hover:opacity-10 transition-opacity hidden md:block">
                            <img src="/assets/builder.png" alt="Icon" className="w-24 h-24 transform rotate-12 grayscale" />
                        </div>
                    </div>

                    {/* Customer Card */}
                    <div
                        onClick={() => handleSelect("customer")}
                        className="group relative bg-white/95 backdrop-blur-sm rounded-2xl p-4 md:p-6 shadow-[0_0_20px_rgba(0,0,0,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.2)] transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-white/10 overflow-hidden flex flex-row md:flex-col items-center md:items-start gap-4"
                    >
                        <div className="bg-blue-50 rounded-xl p-2 md:p-3 flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                            <img src="/assets/young-man.png" alt="Customer" className="w-10 h-10 md:w-16 md:h-16 object-contain" />
                        </div>

                        <div className="flex flex-col text-left">
                            <h3 className="text-lg md:text-2xl font-bold text-gray-900 leading-none mb-1 group-hover:text-blue-600 transition-colors">
                                I am a Customer
                            </h3>
                            <p className="text-gray-600 text-xs md:text-sm mb-2 font-medium leading-tight line-clamp-2">
                                Find verified pros for your dream project.
                            </p>
                            <div className="flex items-center text-blue-600 text-xs md:text-sm font-bold group-hover:translate-x-1 transition-transform">
                                <span>Get Started</span>
                                <svg className="w-3 h-3 md:w-4 md:h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </div>
                        </div>

                        <div className="absolute top-0 right-0 p-2 opacity-5 pointer-events-none group-hover:opacity-10 transition-opacity hidden md:block">
                            <img src="/assets/young-man.png" alt="Icon" className="w-24 h-24 transform rotate-12 grayscale" />
                        </div>
                    </div>

                </div>

            </div>

            <MobileBottomNav />
        </div>
    );
};

export default JoinUs;
